import { toast } from 'react-toastify';
import { getPromoCode } from '@repo/utils/localStorageUtils';
import paymentService from '@/service/payment.service';

export const getPricingPlans = async (promoCode?: string) => {
    const {
        data: {
            result: { items: paymentCart },
        },
    } = await paymentService.getPaymentPlan(promoCode);

    return {
        paymentCart,
    };
};

export const buyPlan = async ({ planId, promoCode, orderId, userId }: any) => {
    const affiliate = getPromoCode();
    await paymentService.buyPlan(userId, planId, promoCode, orderId, affiliate);

    toast.success('Pricing plan successfully bought!');
};
